import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";
import { cn } from "../lib/cn";

/** Colour is never the only signal: every badge carries a word (design system principle 4). */
export const badgeVariants = cva(
  "inline-flex items-center gap-1 whitespace-nowrap rounded-sm px-2 py-0.5 font-medium text-xs tabular",
  {
    variants: {
      tone: {
        neutral: "bg-muted text-foreground",
        outline: "border border-border",
        quiet: "text-muted-foreground",
        danger: "bg-danger-soft text-danger-ink",
        warn: "bg-warn-soft text-warn-ink",
        ok: "bg-ok-soft text-ok-ink",
        brand: "bg-brand-soft text-brand-ink",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export interface BadgeProps
  extends React.ComponentProps<"span">,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span data-slot="badge" className={cn(badgeVariants({ tone }), className)} {...props} />;
}
